// Shared client bound for categorical Watchlist attributes.
// Backend validation remains authoritative.
export const MAX_ATTRIBUTE_CATEGORIES = 50;
